import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca'
import { networkLogos } from 'src/constants/networkLogos'
import { videos } from 'src/constants/videos'
import styled from 'styled-components'
import { sportIds, leagueIds, teamIds } from 'src/constants/personalizationIds'
import { canadaPlanData } from 'src/constants/planData/canadaPlanData'
import { PlanIntervals } from 'src/constants/planData'
export default (props) => {
  return (
    <StyleContainer>
      <CanadaTemplateDefault
        location={props.location}
        lang="en"
        market="canada"
        offerBanner={{
          title: [
            'Special offer activated.',
            'Watch the Buffalo Sabres live for as low as $10.83/mo.',
          ],
        }}
        video={videos.buffalo_sabres.videoUrl}
        videoMobile={videos.buffalo_sabres.videoMobileUrl}
        poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/20231012__JH_4682_1.jpg?w=4096&ch=width&auto=format,compress"
        staticAnnotation={networkLogos.fsn}
        pageTitle="Watch Buffalo Sabres hockey"
        title={
          <>
            Watch Buffalo Sabres<sup>®</sup> hockey
          </>
        }
        subtitle="Get live games, local team coverage & more. Regional restrictions apply."
        plansSubtitle="Canada’s home of the Buffalo Sabres and exclusive live soccer"
        networkSet="canada_sports"
        customNetworks={['fsn']}
        logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-buffalo-sabres-v2.png?ch=width&auto=format,compress"
        logoHeight="100px"
        sportId={sportIds.Hockey}
        leagueId={leagueIds.NHL}
        teamId={teamIds['Buffalo Sabres']}
        planCardsConfig={{
          plans: [canadaPlanData.sabres_offer, canadaPlanData.premium],
          activeTab: PlanIntervals.quarterly,
          overrides: {
            premium: {
              all: {
                promoImg:
                  'https://assets-imgx.fubo.tv/marketing/lp/images/card/ca_card_premium-sabres.jpg',
                listItems: (data) => {
                  const premiumItems = canadaPlanData.premium.listItems(data)
                  return [{ available: true, text: 'LIVE Buffalo Sabres games' }, ...premiumItems]
                },
              },
            },
          },
        }}
      />
    </StyleContainer>
  )
}

const StyleContainer = styled.div`
  .content-container .hero-content {
    max-width: 590px;
  }
`
